import React, { useState } from 'react';
import styled from 'styled-components';
import { LatinoTitleBold } from '..';
import { Text, TextAppearance, TextColor } from '@volkswagen-onehub/components-core';
import { CTATaigo, OptionsDesktop, SlideProps } from '.';

const Div = styled.div`
  width: 100%;
  height: var(--100vh);
  display: flex;
  position: relative;
  background-image: url('https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/taigo_background.png');
  background-size: cover;
`;

const BlueDiv = styled.div<{ isSelected: boolean; otherIsSelected: boolean }>`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgb(0, 130, 214, 0.6);
  left: 0;
  top: 0;
  display: flex;
  clip-path: ${(props) =>
    props.isSelected
      ? 'polygon(0 0, 85% 0, 100% 100%, 0 100%)'
      : props.otherIsSelected
      ? 'polygon(0 0, 0 0, 15% 100%, 0 100%)'
      : 'polygon(0 0, 35% 0, 65% 100%, 0 100%)'};
  justify-content: ${(props) => (props.otherIsSelected ? 'flex-start' : 'center')};
  align-items: ${(props) => (props.otherIsSelected ? 'flex-end' : 'center')};
  padding: ${(props) => (props.otherIsSelected ? '4% 2%' : '0')};
  transition: all 0.5s ease;

  & h1 {
    font-size: ${(props) => (props.otherIsSelected ? '16px !important' : '')};
    @media screen and (min-width: 1280px) {
      font-size: ${(props) => (props.otherIsSelected ? '20px !important' : '')};
    }
    @media screen and (min-width: 1600px) {
      font-size: ${(props) => (props.otherIsSelected ? '24px !important' : '')};
    }
    @media screen and (min-width: 1920px) {
      font-size: ${(props) => (props.otherIsSelected ? '32px !important' : '')};
    }
  }
`;

const RedDiv = styled.div<{ isSelected: boolean; otherIsSelected: boolean }>`
  width: 100%;
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  top: 0;
  clip-path: ${(props) =>
    props.isSelected
      ? 'polygon(0 0, 100% 0, 100% 100%, 15% 100%)'
      : props.otherIsSelected
      ? 'polygon(85% 0, 100% 0, 100% 100%, 100% 100%)'
      : 'polygon(35% 0, 100% 0, 100% 100%, 65% 100%)'};

  display: flex;
  justify-content: ${(props) => (props.otherIsSelected ? 'flex-end' : 'center')};
  align-items: ${(props) => (props.otherIsSelected ? 'flex-start' : 'center')};
  padding: ${(props) => (props.otherIsSelected ? '4% 2%' : '0')};
  transition: all 0.5s ease;
  background-color: rgb(198, 1, 1, 0.6);

  & h1 {
    font-size: ${(props) => (props.otherIsSelected ? '16px !important' : '')};
    @media screen and (min-width: 1280px) {
      font-size: ${(props) => (props.otherIsSelected ? '20px !important' : '')};
    }
    @media screen and (min-width: 1600px) {
      font-size: ${(props) => (props.otherIsSelected ? '24px !important' : '')};
    }
    @media screen and (min-width: 1920px) {
      font-size: ${(props) => (props.otherIsSelected ? '32px !important' : '')};
    }
  }
`;

const Body = styled.div<{ otherIsSelected: boolean; isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.otherIsSelected ? '12px' : '24px')};
  color: #ffffff;
  align-items: center;
  @media screen and (min-width: 960px) {
    gap: ${(props) => (props.otherIsSelected ? '16px' : '24px')};
  }
  @media screen and (min-width: 1600px) {
    gap: ${(props) => (props.otherIsSelected ? '16px' : '32px')};
  }
`;

const BodyBlue = styled(Body)`
  padding-right: ${(props) => (props.isSelected ? '0' : props.otherIsSelected ? '0' : '35%')};
  margin-bottom: ${(props) => (props.otherIsSelected ? '12%' : '')};
  @media screen and (min-width: 960px) {
    margin-bottom: ${(props) => (props.otherIsSelected ? '0' : '')};
  }
`;

const BodyRed = styled(Body)`
  padding-left: ${(props) => (props.isSelected ? '0' : props.otherIsSelected ? '0' : '35%')};
  margin-top: ${(props) => (props.otherIsSelected ? '12%' : '')};
  @media screen and (min-width: 1280px) {
    margin-top: ${(props) => (props.otherIsSelected ? '4%' : '')};
  }
`;

export function FourthSlideDesktop({
  blueSelected,
  setBlueSelected,
  redSelected,
  setRedSelected,
  slideConfig,
  setSelectedJourney,
  fullPageApi,
}: SlideProps) {
  return (
    <Div>
      <BlueDiv isSelected={blueSelected} otherIsSelected={redSelected}>
        {/* <Image /> */}
        <BodyBlue isSelected={blueSelected} otherIsSelected={redSelected} className="body-blue">
          {redSelected ? null : <LatinoTitleBold>{slideConfig.firstDivision.title}</LatinoTitleBold>}
          {blueSelected ? (
            <OptionsDesktop
              setSelectedJourney={setSelectedJourney}
              subtitle={slideConfig.firstDivision.subtitle}
              options={slideConfig.firstDivision.options}
              preButton={slideConfig.firstDivision.preButton}
              ctaCopy="Enviar excusa"
              fullPageApi={fullPageApi}
              estilo='deportivo'
            />
          ) : (
            <CTATaigo
              onClick={() => {
                setBlueSelected(true);
                setRedSelected(false);
              }}
              otherIsSelected={redSelected}
            >
              {redSelected ? 'Entrar' : 'Atrévete…'}
            </CTATaigo>
          )}
          {redSelected ? <LatinoTitleBold>{slideConfig.firstDivision.title}</LatinoTitleBold> : null}
        </BodyBlue>
      </BlueDiv>
      <RedDiv isSelected={redSelected} otherIsSelected={blueSelected}>
        {/* <RedImage /> */}
        <BodyRed isSelected={redSelected} otherIsSelected={blueSelected} className="body-red">
          <LatinoTitleBold>{slideConfig.secondDivision.title}</LatinoTitleBold>
          {redSelected ? (
            <OptionsDesktop
              setSelectedJourney={setSelectedJourney}
              subtitle={slideConfig.secondDivision.subtitle}
              options={slideConfig.secondDivision.options}
              preButton={slideConfig.secondDivision.preButton}
              ctaCopy="Enviar excusa"
              fullPageApi={fullPageApi}
              estilo='urbano'
            />
          ) : (
            <CTATaigo
              onClick={() => {
                setRedSelected(true);
                setBlueSelected(false);
              }}
              otherIsSelected={blueSelected}
            >
              {blueSelected ? 'Entrar' : 'Escápate ya'}
            </CTATaigo>
          )}
        </BodyRed>
      </RedDiv>
    </Div>
  );
}
